var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 23H10.396a2 2 0 0 1-1.967-1.642L5.09 3H2M10.5 28a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M22.5 28a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
  vectorEffect: "non-scaling-stroke"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.819 18h15.694a2 2 0 0 0 1.967-1.642l.38-2.09M6 8h12.5M23 8h6m-3-3v6",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgCartAdd;